import { Component } from 'react';

import { Grid } from '@mui/material';

export default class ProjectDescription extends Component {
  constructor(props) {
    super(props);
    
    const item = props.item;
    const programmingLanguage = item.programmingLanguage;
    const date = item.date;
    this.state = {
      programmingLanguage,
      date,
    }
  }

  render() {
    const {
      programmingLanguage,
      date,
    } = this.state;

    return (
      <Grid container className='project-info' sx={{ justifyContent: 'space-between', justifyItems: 'center', width: '100%' }} >
        <Grid className='note code' size='auto'>
            {programmingLanguage}
        </Grid>
        <Grid className='note' size='auto'>
          {date}
        </Grid>
      </Grid>
    );
  }
}
